import { ActionContext, ActionTree } from 'vuex'
import { mutationType } from './mutation-types'
import PaymentHistoryState, {IPaymentHistory, PaymentHistoryList} from './states'
import CenterState, {CenterList} from '../center/states'
import _ from 'lodash'
import { State } from '@/store/store'
import axios from 'axios'
import HttpRequestServiceWithToken from '@/services/HttpRequestServiceWithToken'

const actions: ActionTree<PaymentHistoryState, State> = {
  async getPaymentHistoryList(
    { commit, dispatch, state }: ActionContext<PaymentHistoryState, State>,
    options: object,
  ): Promise<void> {
    await HttpRequestServiceWithToken
      .getByLevel(process.env.VUE_APP_API_URL + '/v1', 'payment-history', options, (res: PaymentHistoryList) => {
        commit(mutationType.GET_LISTS, res)
      })
  },
  async getPaymentHistoryByJobId(
    { commit, dispatch, state }: ActionContext<PaymentHistoryState, State>,
    options: {[key: string]: any},
  ): Promise<void> {
    const id = options.id
    delete options.id
    await HttpRequestServiceWithToken
    .getByLevel(process.env.VUE_APP_API_URL + '/v1', `payment-history/job/${id}`, options, (res: IPaymentHistory) => {
      commit(mutationType.GET_BY_ID, res)
    })
  },
  async putPaymentHistory(
    { commit, dispatch, state }: ActionContext<PaymentHistoryState, State>,
    options: {[key: string]: any},
  ): Promise<void> {
    const id = options.id
    delete options.id
    await HttpRequestServiceWithToken
      .putByLevel(
        process.env.VUE_APP_API_URL + '/v1', `payment-history/${id}`, options, (res: object) => {
        commit(mutationType.UPDATE, res)
      })
  },
}

export default actions
